import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function About() {
  const [info, setInfo] = useState({ gallery_title: "ART BY John Stam", artist_name: "John Stam" });

  useEffect(() => {
    api.get("/info").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-[1200px] mx-auto px-6 sm:px-10 py-20 fade-up" data-testid="about-page">
      <p className="plaque-label">About the Artist</p>
      <h1 className="font-serif-display font-light text-5xl sm:text-7xl leading-[0.95] mt-4">
        I am perceiving things
        <br />
        that others do not.
      </h1>

      <div className="grid md:grid-cols-12 gap-12 mt-20">
        <div className="md:col-span-7 space-y-6 text-zinc-300 leading-relaxed text-lg">
          <p>
            My name is <span className="text-zinc-100">John Stam</span> — a
            <span className="text-[#D4AF37]"> self-taught</span> artist from{" "}
            <span className="text-zinc-100">Rotterdam, The Netherlands</span>, born in May 1974.
          </p>
          <p>
            I work in <em className="font-serif-display">oil</em> and{" "}
            <em className="font-serif-display">acrylic</em> on canvas, painting the world the way
            it appears from <em className="font-serif-display">inside</em> — my inner life put on a
            wall where it can be looked at.
          </p>
          <p>
            I'm an introvert. Painting is how I speak when words won't do. Each canvas is a
            sentence I'd rather not say out loud.
          </p>
          <p>
            My work is deeply influenced by
            <span className="text-[#D4AF37]"> surrealism</span> and
            <span className="text-[#D4AF37]"> magic realism</span> — two traditions that take the
            ordinary and tilt it just enough for the dream to fall in.
          </p>
          <p>
            For as long as I can remember I've felt
            <em className="font-serif-display"> different</em>. I perceive things that others do not —
            <em className="font-serif-display"> faces and figures in clouds and trees</em>, a
            mouth in a shadow, a body in a branch. I keep what I see, and I paint it back.
          </p>
          <p className="font-serif-display italic text-2xl text-zinc-200 pt-4">
            "If you stand in front of a painting long enough, it begins to look back."
          </p>
          <p className="plaque-label">— John Stam</p>
        </div>

        <aside className="md:col-span-4 md:col-start-9">
          <div className="border border-white/5 p-8 bg-[#0F0F0F]">
            <p className="plaque-label mb-5">The Studio</p>
            <dl className="space-y-3 text-sm">
              <div className="flex justify-between gap-4">
                <dt className="text-zinc-500">Based in</dt>
                <dd className="text-zinc-200 text-right">Rotterdam, NL</dd>
              </div>
              <div className="flex justify-between gap-4">
                <dt className="text-zinc-500">Born</dt>
                <dd className="text-zinc-200 text-right">May 1974</dd>
              </div>
              <div className="flex justify-between gap-4">
                <dt className="text-zinc-500">Practice</dt>
                <dd className="text-zinc-200 text-right">Self-taught</dd>
              </div>
              <div className="flex justify-between gap-4">
                <dt className="text-zinc-500">Medium</dt>
                <dd className="text-zinc-200 text-right">Oil &amp; acrylic on canvas</dd>
              </div>
              <div className="flex justify-between gap-4">
                <dt className="text-zinc-500">Influences</dt>
                <dd className="text-zinc-200 text-right">Surrealism · Magic realism</dd>
              </div>
            </dl>
          </div>
          <div className="mt-6 border border-white/5 p-8 bg-[#0F0F0F]">
            <p className="plaque-label mb-4">For Collectors</p>
            <p className="text-sm text-zinc-400 leading-relaxed mb-6">
              All works are available for private viewing, commissioning, or acquisition. Inquiries
              are answered personally.
            </p>
            <a
              href="/inquire"
              className="text-xs tracking-[0.3em] uppercase border-b border-[#D4AF37] pb-1 text-[#D4AF37] hover:text-white hover:border-white"
              data-testid="about-inquire-link"
            >
              Contact the artist →
            </a>
          </div>
          <div className="mt-6 border border-white/5 p-8 bg-[#0F0F0F]">
            <p className="plaque-label mb-4">Follow the Studio</p>
            <a
              href="https://www.instagram.com/art_by_john_stam/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-zinc-200 hover:text-[#D4AF37] transition-colors"
              data-testid="about-instagram-link"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
              </svg>
              <span className="font-serif-display text-xl italic">@art_by_john_stam</span>
            </a>
          </div>
        </aside>
      </div>
    </div>
  );
}
